export default __webpack_public_path__ + "static/media/wapp.451db174.png";